module.exports = __webpack_public_path__ + "img/f2-5.db3d3e3c.jpg";